import React from 'react'
import logo from '../images/header-canfax.png'

export default class NotFound extends React.Component {
  render() {
    return (
      <div style={{textAlign: 'center'}}>
        <img
          src={logo}
          alt="CanFax Logo"
          style={{paddingTop: '10px', paddingBottom: '10px'}}
        />
        <p style={{color: 'white', fontSize: '30px'}}>Page Not Found</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/404notfound.js